export default __webpack_public_path__ + "locales/sl/DataReassignmentDialog.json?hash=a72c109a7033e2d70f0d3bc2b664416f";